<app-abstract-dialog class="submit-dialog"
                     [dialogWidth]="'800'"
                     [playButtonActive]="true"
                     [ttsIconState]="ttsIconState"
                     [showCloseButton]="dialogData.logout"
                     [repeatButtonActive]="repeatButtonActive"
                     (readTextEvent)="readText()"
                     (playAudioEvent)="playAudio()"
                     (closeEvent)="onClose()">

    <ng-container abstract-header>
        <h3 class="abstract-dialog__header__title">{{dialogData.title}}</h3>
    </ng-container>

    <ng-container abstract-content>
        <p class="abstract-dialog__content__text">{{dialogData.description}}</p>

        <div class="submit-dialog__content">
            <div role="button" tabindex=0 class="submit-dialog__content__content-box" *ngIf="!dialogData.logout"
                 [attr.aria-label]="('CONSENT.SUBMIT_DIALOG.COMPLETED.GO_TO_DASHBOARD' | translate) + ('GENERAL.BUTTON' | translate)"
                 (keyup)="keyUpGoToDashBoard($event)"
                 (click)="onGoToDashboard()">
                <mat-icon class="material-icons-round custom-icon" svgIcon='dashboard'></mat-icon>
                <p class="submit-dialog__content__content-box__title">{{'CONSENT.SUBMIT_DIALOG.COMPLETED.GO_TO_DASHBOARD' | translate}}</p>
                <p class="submit-dialog__content__content-box__text">{{'CONSENT.SUBMIT_DIALOG.COMPLETED.GO_TO_DASHBOARD_TEXT' | translate}}</p>
            </div>
            <div role="button" tabindex=0 class="submit-dialog__content__content-box" *ngIf="dialogData.logout"
                 [attr.aria-label]="('CONSENT.SUBMIT_DIALOG.COMPLETED.LOGOUT' | translate) + ('GENERAL.BUTTON' | translate)"
                 (keyup)="keyUpRestartApp($event)"
                 (click)="restartApplication()">
                <mat-icon class="material-icons-round">logout</mat-icon>
                <p class="submit-dialog__content__content-box__title">{{'CONSENT.SUBMIT_DIALOG.COMPLETED.LOGOUT' | translate }}</p>
                <p class="submit-dialog__content__content-box__text">{{'CONSENT.SUBMIT_DIALOG.COMPLETED.LOGOUT_TEXT' | translate}}</p>
            </div>
            <div role="button" tabindex=0 class="submit-dialog__content__content-box"
                 [attr.aria-label]="('CONSENT.SUBMIT_DIALOG.COMPLETED.GO_TO_QUESTIONNAIRE' | translate) + ('GENERAL.BUTTON' | translate)"
                 (keyup)="keyUpGoToQuestionnaire($event)"
                 (click)="goToQuestionnaire()">
                <mat-icon class="material-icons-round custom-icon" svgIcon='questionnaire'></mat-icon>
                <p class="submit-dialog__content__content-box__title">{{'CONSENT.SUBMIT_DIALOG.COMPLETED.GO_TO_QUESTIONNAIRE' | translate}}</p>
                <p class="submit-dialog__content__content-box__text">{{'CONSENT.SUBMIT_DIALOG.COMPLETED.GO_TO_QUESTIONNAIRE_TEXT' | translate}}</p>
            </div>
        </div>
    </ng-container>

    <ng-container abstract-footer *ngIf="viewIndicationCompleted">
        <app-button
                [cssClasses]="'btn full-width solid__blue-07'"
                [ariaLabel]="('GENERAL.BACK_TO_CONTENT' | translate) + ('GENERAL.BUTTON' | translate)"
                (buttonClicked)="close()">
            {{'GENERAL.BACK_TO_CONTENT' | translate }}
        </app-button>
    </ng-container>

</app-abstract-dialog>
